/* De Pubgolf Koning - productpagina gedrag. Leest alle data uit <script id="pgk-data">. */
(function () {
  'use strict';
  var el = document.getElementById('pgk-data');
  if (!el) return;
  var R;
  try { R = JSON.parse(el.textContent); } catch (e) { console.error('pgk-data', e); return; }

  var DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var SHORT = { Mon: 'Ma', Tue: 'Di', Wed: 'Wo', Thu: 'Do', Fri: 'Vr', Sat: 'Za', Sun: 'Zo' };
  var LONG = { Mon: 'maandag', Tue: 'dinsdag', Wed: 'woensdag', Thu: 'donderdag', Fri: 'vrijdag', Sat: 'zaterdag', Sun: 'zondag' };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var win = function (v, d) { return (R.schedule[v] || {})[d] || null; };
  var playableNames = function (v) { return DAYS.filter(function (d) { return win(v, d); }).map(function (d) { return LONG[d]; }).join(', '); };

  // ---------------------------------------------------------- variant picker
  var picker = $('#pgk-holes');
  var currentV = (function () { var a = picker && $('.pgk-ph__hole-pill--active', picker); return a ? a.dataset.holes : '16'; })();

  function setVariant(variantId) {
    var vi = document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
             document.querySelector('form[action*="/cart/add"] select[name="id"]') ||
             document.querySelector('input[name="id"]') ||
             document.querySelector('[data-productid] input[name="id"]');
    if (vi) {
      vi.value = variantId;
      vi.dispatchEvent(new Event('change', { bubbles: true }));
      vi.dispatchEvent(new Event('input', { bubbles: true }));
    }
    try { var u = new URL(location.href); u.searchParams.set('variant', variantId); history.replaceState({}, '', u.toString()); } catch (e) {}
    var native = document.querySelector('input[type="radio"][value="' + variantId + '"], select option[value="' + variantId + '"]');
    if (native) {
      if (native.tagName === 'OPTION') { native.selected = true; native.parentElement.dispatchEvent(new Event('change', { bubbles: true })); }
      else { native.checked = true; native.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    document.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: { id: parseInt(variantId, 10) } } }));
  }

  if (picker) {
    picker.addEventListener('click', function (e) {
      var b = e.target.closest('.pgk-ph__hole-pill');
      if (!b) return;
      $$('.pgk-ph__hole-pill', picker).forEach(function (x) { x.classList.remove('pgk-ph__hole-pill--active'); });
      b.classList.add('pgk-ph__hole-pill--active');
      setVariant(b.dataset.variantId);
      var price = $('#pgk-price');
      if (price && b.dataset.price) {
        price.innerHTML = '<span class="pgk-ph__price-main">' + b.dataset.price + '</span>' +
          (b.dataset.compare ? '<span class="pgk-ph__price-old">' + b.dataset.compare + '</span><span class="pgk-ph__price-badge">Aanbieding</span>' : '');
      }
      currentV = b.dataset.holes;
      renderHeaderChips();
      selectPlayVariant(currentV);
    });
  }

  // ---------------------------------------------------------- header: wanneer spelen
  var chipsWrap = $('#pgk-when-chips'), result = $('#pgk-when-result'), vLabel = $('#pgk-when-variant');
  var selDay = null;

  function renderHeaderChips() {
    if (!chipsWrap) return;
    if (vLabel) vLabel.textContent = currentV;
    $$('.pgk-ph__when-chip', chipsWrap).forEach(function (btn) {
      var open = !!win(currentV, btn.dataset.day);
      btn.classList.toggle('closed', !open);
      btn.disabled = !open;
      if (!open) btn.classList.remove('sel');
    });
    if (selDay) showDay(selDay);
  }

  function showDay(d) {
    var w = win(currentV, d);
    var link = '<br><button type="button" class="pgk-ph__when-link" data-pgk-goto-when>Zie exacte tijden per variant &#8594;</button>';
    if (!w) {
      result.className = 'pgk-ph__when-result show pgk-ph__when-nok';
      result.innerHTML = '<strong>Niet speelbaar.</strong> Op ' + LONG[d] + ' zijn te veel kroegen gesloten voor ' + currentV + ' holes. Speelbaar op ' + (playableNames(currentV) || 'geen enkele dag') + '.' + link;
    } else {
      result.className = 'pgk-ph__when-result show pgk-ph__when-ok';
      result.innerHTML = '<strong>Speelbaar!</strong> Start op ' + LONG[d] + ' tussen <strong>' + w.min + '</strong> en <strong>' + w.max + '</strong> voor ' + currentV + ' holes.' + link;
    }
  }

  if (chipsWrap && result) {
    chipsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.pgk-ph__when-chip');
      if (!btn || btn.disabled) return;
      $$('.pgk-ph__when-chip', chipsWrap).forEach(function (b) { b.classList.remove('sel'); });
      btn.classList.add('sel');
      selDay = btn.dataset.day;
      showDay(selDay);
    });
    result.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pgk-goto-when]')) return;
      var acc = $('#pgk-acc-when');
      if (acc) { acc.open = true; acc.scrollIntoView({ behavior: 'smooth' }); }
    });
  }

  // ---------------------------------------------------------- help modal
  var help = $('#pgk-help-modal'), helpBtn = $('#pgk-help-btn');
  function openHelp() { help.classList.add('open'); help.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function closeHelp() { help.classList.remove('open'); help.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  if (help && helpBtn) {
    helpBtn.addEventListener('click', openHelp);
    help.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) return closeHelp();
      var t = e.target.closest('.pgk-ph__modal-tab');
      if (!t) return;
      $$('.pgk-ph__modal-tab', help).forEach(function (x) { x.classList.remove('active'); });
      $$('.pgk-ph__hole-panel', help).forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var p = $('[data-panel="' + t.dataset.hole + '"]', help);
      if (p) p.classList.add('active');
    });
  }

  // ---------------------------------------------------------- info: starttijdenchecker
  var daySel = $('#pgk-day'), playChips = $('#pgk-play-chips'), reco = $('#pgk-play-reco'), rows = $('#pgk-play-rows');
  var playV = (function () { var a = playChips && $('.pgk-info__play-chip.active', playChips); return a ? a.dataset.variant : currentV; })();

  function renderPlay() {
    if (!daySel || !reco || !rows) return;
    var d = daySel.value;
    if (d === 'ALL') {
      reco.innerHTML = 'Kies een dag hierboven om de exacte starttijd voor <strong>' + playV + ' holes</strong> te zien.';
    } else {
      var w = win(playV, d);
      reco.innerHTML = w
        ? '<span class="pgk-info__tag pgk-info__tag--yes">Speelbaar</span> Start op ' + LONG[d] + ' tussen <strong>' + w.min + '</strong> en <strong>' + w.max + '</strong> voor de ' + playV + '-holes route.'
        : '<span class="pgk-info__tag pgk-info__tag--no">Niet speelbaar</span> Op ' + LONG[d] + ' kun je de ' + playV + '-holes route niet spelen. Kies ' + (playableNames(playV) || 'een andere variant') + '.';
    }
    rows.innerHTML = DAYS.map(function (day) {
      var w = win(playV, day);
      return '<div class="pgk-info__open-row"><div data-label="Dag">' + SHORT[day] + '</div>' +
        '<div data-label="Status"><span class="pgk-info__open-pill ' + (w ? 'pgk-info__open-pill--yes">Speelbaar' : 'pgk-info__open-pill--no">Gesloten') + '</span></div>' +
        '<div data-label="Vroegst">' + (w ? w.min : '&mdash;') + '</div><div data-label="Laatste start">' + (w ? w.max : '&mdash;') + '</div></div>';
    }).join('');
  }

  function selectPlayVariant(v) {
    if (!playChips) return;
    var chip = $('.pgk-info__play-chip[data-variant="' + v + '"]', playChips);
    if (!chip) return;
    $$('.pgk-info__play-chip', playChips).forEach(function (c) { c.classList.remove('active'); });
    chip.classList.add('active');
    playV = v;
    renderPlay();
  }

  if (daySel && playChips) {
    daySel.addEventListener('change', renderPlay);
    playChips.addEventListener('click', function (e) {
      var c = e.target.closest('.pgk-info__play-chip');
      if (c) selectPlayVariant(c.dataset.variant);
    });
    renderPlay();
    selectPlayVariant(currentV); // checker start op dezelfde variant als de gekozen holes bovenaan
  }

  // ---------------------------------------------------------- email-gate voorbeeldroute
  var overlay = $('#pgk-overlay');
  function openGate() { if (!overlay) return; overlay.classList.add('open'); overlay.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; setTimeout(function () { var i = $('#pgk-email'); if (i) i.focus(); }, 350); }
  function closeGate() { if (!overlay) return; overlay.classList.remove('open'); overlay.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pgk-open-preview]')) { e.preventDefault(); openGate(); }
    if (e.target.closest('[data-pgk-close]')) closeGate();
    if (e.target.closest('[data-pgk-scroll-top]')) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeGate(); if (help) closeHelp(); } });

  var form = $('#pgk-gate-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('#pgk-email'), err = $('#pgk-error'), email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.classList.add('show'); input.style.borderColor = '#c0392b'; input.focus(); return; }
      err.classList.remove('show'); input.style.borderColor = '';
      if (R.klaviyo_list_id) {
        var fd = new URLSearchParams();
        fd.append('g', R.klaviyo_list_id);
        fd.append('email', email);
        fd.append('$source', 'Preview popup ' + R.city);
        fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: fd.toString() })
          .catch(function (x) { console.error(x); });
      }
      window.open(R.preview_url, '_blank', 'noopener');
      $('#pgk-form-state').style.display = 'none';
      $('#pgk-success-state').style.display = 'block';
    });
  }

  // ---------------------------------------------------------- telefoon-slider
  var slides = $('#pgk-slides'), dots = $$('#pgk-dots .pgk-dot'), caps = $$('#pgk-captions .pgk-phone__cap');
  if (slides && dots.length) {
    var setActive = function (i) {
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
      caps.forEach(function (c, k) { c.classList.toggle('active', k === i); });
    };
    slides.addEventListener('scroll', function () { setActive(Math.round(slides.scrollLeft / slides.offsetWidth)); }, { passive: true });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { slides.scrollTo({ left: slides.offsetWidth * i, behavior: 'smooth' }); }); });
  }
})();